import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateWithTransition } from '../../hooks/useNavigateWithTransition';

interface TransitionNavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string | ((props: { isActive: boolean }) => string);
  onClick?: () => void;
}

const TransitionNavLink: React.FC<TransitionNavLinkProps> = ({ 
  to, 
  children, 
  className, 
  onClick 
}) => {
  const navigateWithTransition = useNavigateWithTransition();
  const location = useLocation();
  
  const isActive = location.pathname === to;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    // Execute any additional onClick handlers
    if (onClick) {
      onClick();
    }
    
    // Don't transition if we're already on the target page
    if (isActive) {
      return;
    }
    
    // Start the page transition
    navigateWithTransition(to);
  };

  // Resolve className
  const resolvedClassName = typeof className === 'function' 
    ? className({ isActive }) 
    : className || '';

  return (
    <a
      href={to}
      className={resolvedClassName}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default TransitionNavLink; 